export const AdminActionTypes = {
    FETCH_ALL_USERS_START: 'FETCH_ALL_USERS_START',
    FETCH_ALL_USERS_SUCCESS: 'FETCH_ALL_USERS_SUCCESS',
    FETCH_ALL_USERS_FAILURE: 'FETCH_ALL_USERS_FAILURE',    
    FETCH_USERS_START: 'FETCH_USERS_START',
    FETCH_USERS_SUCCESS: 'FETCH_USERS_SUCCESS',
    FETCH_USERS_FAILURE: 'FETCH_USERS_FAILURE',    

    GET_ALL_USERS: 'GET_ALL_USERS',
    SET_USERS: 'SET_USERS',
    SET_USERS_ON_PAGE: 'SET_USERS_ON_PAGE',
    SET_SEARCH_QUERY: 'SET_SEARCH_QUERY',
    SET_SEARCH_QUERY_USERS: 'SET_SEARCH_QUERY_USERS',

    ADD_SELECTED_USER: 'ADD_SELECTED_USER',
    DELETE_SELECTED_USER: 'DELETE_SELECTED_USER',
    SET_SELECTED_USER: 'SET_SELECTED_USER',


    SET_ADMIN_TAB: 'SET_ADMIN_TAB',
    LOAD_ROLES_START: 'LOAD_ROLES_START',
    SET_ALL_ROLES: 'SET_ALL_ROLES',

//deprecate department
    FETCH_DEPARTMENTS_START: 'FETCH_DEPARTMENTS_START',
    SET_ALL_DEPARTMENTS: 'SET_ALL_DEPARTMENTS',
    FETCH_DEPARTMENTS_SUCCESS: 'FETCH_DEPARTMENTS_SUCCESS',
    FETCH_DEPARTMENTS_FAILURE: 'FETCH_DEPARTMENTS_FAILURE',
    SET_DEPARTMENTS_ON_PAGE: 'SET_DEPARTMENTS_ON_PAGE',
    SET_SEARCH_DEPARTMENTS_QUERY: 'SET_SEARCH_DEPARTMENTS_QUERY',
    ADD_SELECTED_DEPARTMENT: 'ADD_SELECTED_DEPARTMENT',
    DELETE_SELECTED_DEPARTMENT: 'DELETE_SELECTED_DEPARTMENT',
    SET_SELECTED_DEPARTMENT: 'SET_SELECTED_DEPARTMENT',


    FETCH_GROUPS_START: 'FETCH_GROUPS_START',
    FETCH_GROUPS_SUCCESS: 'FETCH_GROUPS_SUCCESS',
    FETCH_GROUPS_FAILURE: 'FETCH_GROUPS_FAILURE',    
    GET_ALL_GROUPS: 'GET_ALL_GROUPS',
    SET_GROUPS_ON_PAGE: 'SET_GROUPS_ON_PAGE',
    SET_SEARCH_GROUPS_QUERY: 'SET_SEARCH_GROUPS_QUERY',
    ADD_SELECTED_GROUP: 'ADD_SELECTED_GROUP',
    DELETE_SELECTED_GROUP: 'DELETE_SELECTED_GROUP',
    SET_SELECTED_GROUP: 'SET_SELECTED_GROUP',


    FETCH_ROLES_START: 'FETCH_ROLES_START',
    FETCH_ROLES_SUCCESS: 'FETCH_ROLES_SUCCESS',
    FETCH_ROLES_FAILURE: 'FETCH_ROLES_FAILURE',
    SET_SEARCH_ROLES_QUERY: 'SET_SEARCH_ROLES_QUERY',
    ADD_SELECTED_ROLE: 'ADD_SELECTED_ROLE',
    DELETE_SELECTED_ROLE: 'DELETE_SELECTED_ROLE',
    SET_SELECTED_ROLE: 'SET_SELECTED_ROLE',
    SET_ROLES_ON_PAGE: 'SET_ROLES_ON_PAGE',



    FETCH_LOGS_START: 'FETCH_LOGS_START',
    FETCH_LOGS_SUCCESS: 'FETCH_LOGS_SUCCESS',
    FETCH_LOGS_FAILURE: 'FETCH_LOGS_FAILURE',    
    GET_ALL_LOGS: 'GET_ALL_LOGS',
    SET_SEARCH_LOGS_QUERY: 'SET_SEARCH_LOGS_QUERY',
    ADD_SELECTED_LOG: 'ADD_SELECTED_LOG',
    DELETE_SELECTED_LOG: 'DELETE_SELECTED_LOG',
    SET_SELECTED_LOG: 'SET_SELECTED_LOG',

    // for project templates
    FETCH_TEMPLATES_START: 'FETCH_TEMPLATES_START',
    FETCH_TEMPLATES_SUCCESS: 'FETCH_TEMPLATES_SUCCESS',
    FETCH_TEMPLATES_FAILURE: 'FETCH_TEMPLATES_FAILURE',
    SET_SEARCH_TEMPLATES_QUERY: 'SET_SEARCH_TEMPLATES_QUERY',
    ADD_SELECTED_TEMPLATE: 'ADD_SELECTED_TEMPLATE',
    DELETE_SELECTED_TEMPLATE: 'DELETE_SELECTED_TEMPLATE',
    SET_SELECTED_TEMPLATE: 'SET_SELECTED_TEMPLATE',
    SET_TEMPLATES_ON_PAGE: 'SET_TEMPLATES_ON_PAGE',

    // for tasks of individual templates
    FETCH_TEMPLATE_TASKS_START: 'FETCH_TEMPLATE_TASKS_START',
    FETCH_TEMPLATE_TASKS_SUCCESS: 'FETCH_TEMPLATE_TASKS_SUCCESS',
    FETCH_TEMPLATE_TASKS_FAILURE: 'FETCH_TEMPLATE_TASKS_FAILURE',
    SET_SEARCH_TEMPLATE_TASKS_QUERY: 'SET_SEARCH_TEMPLATE_TASKS_QUERY',
    ADD_SELECTED_TEMPLATE_TASKS: 'ADD_SELECTED_TEMPLATE_TASKS',
    DELETE_SELECTED_TEMPLATE_TASKS: 'DELETE_SELECTED_TEMPLATE_TASKS',
    SET_SELECTED_TEMPLATE_TASKS: 'SET_SELECTED_TEMPLATE_TASKS',
    SET_TEMPLATE_TASKS_ON_PAGE: 'SET_TEMPLATE_TASKS_ON_PAGE',
}